export default "__VITE_ASSET__C53QLBxs__"